import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { InvoicePointService } from '../../../../services/invoice-cash-desk/invoice-point.service';
import { CashDeskService } from '../../../../services/cash-desk.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ServiceFilter } from '../../../../model/service-filter';
import { CashDeskPaymentFilter } from '../../../../model/cash-desk-payment-filter';
import { InvoicePoint } from '../../../../model/invoice-point';
import { IFilterComponent, SearchFilter } from 'src/app/infrastructure/iFilter-component';
import { FilterRecordService } from '../../../../services/filter-record.service';
import { CashDeskCloseControlService } from '../../../../services/cash-desk-close-control/cash-desk-close-control.service';
import { FilterCompleteService } from '../../../../filter-complete/filter-complete';
import { FilterService } from '../../../../services/filter.service';

@Component({
  selector: 'app-cash-desk-close-control-filter',
  templateUrl: './cash-desk-close-control-filter.component.html',
  styleUrls: ['./cash-desk-close-control-filter.component.css']
})
export class CashDeskCloseControlFilterComponent  implements IFilterComponent, OnInit {

  @ViewChild('formElement', {static: false}) formElement: ElementRef;
  form: FormGroup;
  filterCompleteServices: FilterCompleteService<ServiceFilter>;
  filterCompletePayments: FilterCompleteService<CashDeskPaymentFilter>;
  filterCompleteInvoicePoints: FilterCompleteService<InvoicePoint>;

  constructor( private invoicePointService: InvoicePointService,
               private filterService: FilterService,
               private cashDeskService: CashDeskService,
               private cashDeskCloseControlService: CashDeskCloseControlService,
               private filterRecordService: FilterRecordService,
               private formBuilder: FormBuilder, ) {
                this.form = this.formBuilder.group({
                  protocol: [''],
                  closeNumber: [''],
                  payment: [ '' ],
                  from: [ new Date(), Validators.required ],
                  to: [ new Date(), Validators.required ],
                  service: [''],
                  invoicePoint: [''],
                  controled: [ true ],
                  noControled: [ true ],
                  observated: [ true ]
                });

    this.filterCompletePayments = new FilterCompleteService<CashDeskPaymentFilter>([], this.form.controls.payment);
    this.filterCompleteServices = new FilterCompleteService<ServiceFilter>([], this.form.controls.service);
    this.filterCompleteInvoicePoints = new FilterCompleteService<InvoicePoint>([], this.form.controls.invoicePoint);
  }

  get f() { return this.form.controls; }
  get filteredServicesOptions() {
    return this.filterCompleteServices ? this.filterCompleteServices.filteredOptions : []; }
  get filteredPaymentsOptions() {
      return this.filterCompletePayments ? this.filterCompletePayments.filteredOptions : []; }
  get filteredInvoicePointsOptions() {
      return this.filterCompleteInvoicePoints ? this.filterCompleteInvoicePoints.filteredOptions : []; }

  ngOnInit() {
    this.invoicePointService.getInvoicePointsCashDesk().then((info) => {
      this.filterCompleteInvoicePoints =
      new FilterCompleteService<InvoicePoint>(info, this.form.controls.invoicePoint);
    });

    this.filterService.getServicesFilter().then((info) => {
      this.filterCompleteServices =
      new FilterCompleteService<ServiceFilter>(info, this.form.controls.service);
    });

    this.cashDeskService.getCashDeskPaymentFilters().then((info) => {
      this.filterCompletePayments =
      new FilterCompleteService<CashDeskPaymentFilter>(info, this.form.controls.payment);
    });
  }

  saveFilters(): void {
    this.filterRecordService.saveFilters('CashDeskCloseControlFilterComponent', this.form);
  }
  setFilters(): boolean {
    return this.filterRecordService.setFilters('CashDeskCloseControlFilterComponent', this.form);
  }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    requiredTags.push('from');
    requiredTags.push('to');
    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  async search(): Promise<any> {
    return await this.cashDeskCloseControlService
    .getCashDeskCloseControlSearchItem(
        this.form.controls.protocol.value,
        <Date>this.form.controls.from.value,
        <Date>this.form.controls.to.value,
        this.form.controls.noControled.value,
        this.form.controls.controled.value,
        this.form.controls.observated.value,
        (this.form.controls.service.value ? this.form.controls.service.value.Id : null),
        (this.form.controls.closeNumber.value ? this.form.controls.closeNumber.value : null),
        (this.form.controls.payment.value ? this.form.controls.payment.value.Id : null),
        (this.form.controls.invoicePoint.value ? this.form.controls.invoicePoint.value.Id : null));
  }
}
